import { atom } from 'jotai';

export const $cpSelectedRoleIds = atom<string[]>([]);
export const $cpSelectedInvitationIds = atom<string[]>([]);

export const $cpRolesOffset = atom<number>(0);
export const $cpRolesLimit = atom<number>(20);

export const $cpUsersOffset = atom<number>(0);
export const $cpUsersLimit = atom<number>(20);

export const $cpRolesSearchTerm = atom<string>('');
export const $cpUsersSearchTerm = atom<string>('');
